import { graphql } from 'gql';

export const uerGlobalOtherCostsForContractGql = graphql(`
    query globalOtherCostsForContract(
        $skip: Int
        $take: Int
        $contractId: Long!
        $order: [GlobalOtherCostDataSortInput!]
    ) {
        uerGlobalOtherCostsForContract(skip: $skip, take: $take, contractId: $contractId, order: $order) {
            items {
                id
                name
                methodology
                calculatingType
                chapter
                section
                otherCostType {
                    name
                    id
                    uniqueId
                }
                formula
                isSystem
            }
        }
    }
`);

export const uerCreateContractOtherCostGql = graphql(`
    mutation uerCreateContractOtherCost($contractId: Long!, $createInput: ContractOtherCreateInput!) {
        uerCreateContractOtherCost(contractId: $contractId, createInput: $createInput) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerCreateContractOtherCostFromCatalogGql = graphql(`
    mutation uerCreateContractOtherCostFromCatalog(
        $contractId: Long!
        $createInput: ContractOtherCreateFromCatalogInput!
    ) {
        uerCreateContractOtherCostFromCatalog(contractId: $contractId, createInput: $createInput) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerIsUniqueContractOtherCostKeyGql = graphql(`
    query uerIsUniqueContractOtherCostKey($contractId: Long!, $contractOtherCostId: Long, $key: String) {
        uerIsUniqueContractOtherCostKey(contractId: $contractId, contractOtherCostId: $contractOtherCostId, key: $key) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimGlobalOtherCostsForContractGql = graphql(`
    query bimGlobalOtherCostsForContract(
        $contractId: Long!
        $skip: Int
        $take: Int
        $where: GlobalOtherCostDataFilterInput
        $order: [GlobalOtherCostDataSortInput!]
    ) {
        bimGlobalOtherCostsForContract(
            skip: $skip
            take: $take
            where: $where
            contractId: $contractId
            order: $order
        ) {
            items {
                id
                name
                methodology
                calculatingType
                chapter
                section
                formula
                isSystem
                otherCostType {
                    uniqueId
                    id
                    name
                }
            }
        }
    }
`);

export const bimCreateContractConditionOtherCostGql = graphql(`
    mutation bimCreateContractConditionOtherCost($input: BimContractConditionOtherCostInput!) {
        bimCreateContractConditionOtherCost(input: $input) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

// -- bim from WorkOrder --
export const bimCreateOtherToWorkOrderFromCatalogGgl = graphql(`
    mutation bimCreateWorkOrderOtherFromCatalog($workOrderId: Long!, $input: BimContractOtherCostFromCatalogInput!) {
        bimCreateWorkOrderOtherFromCatalog(workOrderId: $workOrderId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateOtherToWorkOrderFromInputGql = graphql(`
    mutation bimCreateWorkOrderOtherFromInput($workOrderId: Long!, $input: BimContractOtherCostInput!) {
        bimCreateWorkOrderOtherFromInput(workOrderId: $workOrderId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderOtherFromCatalogForActGql = graphql(`
    mutation bimCreateWorkOrderOtherFromCatalogForAct(
        $input: BimContractOtherCostFromCatalogInput!
        $workOrderObjectId: Long!
    ) {
        bimCreateWorkOrderOtherFromCatalogForAct(input: $input, workOrderObjectId: $workOrderObjectId) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderOtherFromInputForActGql = graphql(`
    mutation bimCreateWorkOrderOtherFromInputForAct($input: BimContractOtherCostInput!, $workOrderObjectId: Long!) {
        bimCreateWorkOrderOtherFromInputForAct(input: $input, workOrderObjectId: $workOrderObjectId) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

// -- bim from WorkOrder Change --
export const bimCreateWorkOrderChangeOtherFromCatalogGql = graphql(`
    mutation bimCreateWorkOrderChangeOtherFromCatalog(
        $workOrderChangeId: Long!
        $input: BimContractOtherCostFromCatalogInput!
    ) {
        bimCreateWorkOrderChangeOtherFromCatalog(workOrderChangeId: $workOrderChangeId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
export const bimCreateWorkOrderChangeOtherFromInputGql = graphql(`
    mutation bimCreateWorkOrderChangeOtherFromInput($workOrderChangeId: Long!, $input: BimContractOtherCostInput!) {
        bimCreateWorkOrderChangeOtherFromInput(workOrderChangeId: $workOrderChangeId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
